import accountStyles from './account-option.style';
import { useState } from 'react';
import LoadingIcon from 'components/loading/LoadingIcon';
import userApi from 'apis/userApi';
import toast from 'react-hot-toast';
import styles from './account-option.style';

function GiftCodeAccount() {
    const [giftCode, setGiftCode] = useState('');
    const [loading, setLoading] = useState(false);
    const submitGiftCode = async () => {
        if (!giftCode) {
            toast.error('Mã quà tặng không hợp lệ');
            return;
        }
        const params = {
            giftcode: giftCode,
        };
        setLoading(true);
        try {
            const { data } = await userApi.sendGiftCode(params);
            if (!data.msg) {
                if (data.errorCode === 0) {
                    toast.success(data.msg);
                    setGiftCode('');
                } else {
                    toast.error(data.msg);
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className={accountStyles.wrap}>
                <div>
                    <h6 className={accountStyles.title}>Nhập Mã quà tặng</h6>
                    <div className={`${accountStyles.groupInput} giftCode` }>
                        <label className={accountStyles.label} htmlFor="giftCode">
                            Mã ưu đãi của bạn
                        </label>
                        <input id="giftCode" type="text" className="input-common" placeholder="Mã quà tặng" onChange={(e) => setGiftCode(e.target.value)} />
                    </div>
                    <div className={`${styles.elmSubmit}`}>
                        <button type="button" className={`${accountStyles.btnSubmit} btn-primary`} style={{ width: '100%' }} onClick={submitGiftCode}>
                            Lưu
                        </button>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

export default GiftCodeAccount;
